import React, { useEffect, useState } from "react";
import { Select, message } from "antd";
import axios from "axios";

/**
 * Courier selector backed by the API's canonical courier list, which already excludes instant,
 * hidden, retired and inactive couriers. Every courier selector must use this rather than
 * SERVICE_PROVIDER_DETAILS, which carries couriers the backend will reject.
 *
 * Forwards all props to antd Select, so it works inside Form.Item and in single or multiple mode.
 */
const CourierSelect = (props) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const fetchCouriers = async () => {
      try {
        const res = await axios.get("/api/service-providers");
        if (!active) return;
        setOptions(
          (res.data.data || []).map((courier) => ({
            label: courier.name,
            value: courier.key,
          })),
        );
      } catch (error) {
        // No fallback to the local list: offering couriers the backend rejects is the bug this fixes.
        if (active) {
          message.error(
            `Failed to load couriers: ${
              error.response?.data?.message || error.message
            }`,
          );
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchCouriers();

    return () => {
      active = false;
    };
  }, []);

  return (
    <Select
      options={options}
      loading={loading}
      optionFilterProp="label"
      {...props}
    />
  );
};

export default CourierSelect;
